module.exports = __webpack_public_path__ + "img/indus-pic-2.195d9495.png";